/**
 * @desc 查询库存列表
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockSkuGetQry, options?: any) {
  return updateResponse(
    http(URL + `/stock/getStockSkuList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
